<template>
  <div class="row">
    <div class="col-12">
      <input-select-search
        ref="produto"
        v-model="form.produtoId"
        :label="$t(`SUPRIMENTOS.SELECIONE_PRODUTO_PARA_TRANSFERENCIA`)"
        :options="opcoes.produtos"
        @input="buscaDepositoQuantidadeTotal"
        required
      />
    </div>

    <div class="col-12">
      <input-select-search
        ref="depositoVelho"
        v-model="form.depositoAntigoId"
        :label="$t(`SUPRIMENTOS.SELECIONE_DEPOSITO_ANTIGO`)"
        @input="buscaDepositoQuantidadeTotal"
        :options="depositos"
        required
      />
    </div>

    <div class="col-12">
      <input-select-search
        ref="depositoNovo"
        v-model="form.depositoNovoId"
        :label="$t(`SUPRIMENTOS.SELECIONE_DEPOSITO_NOVO`)"
        :options="depositos"
        required
      />
    </div>

    <div class="col-6">
      <input-text
        ref="quantidadeTotal"
        :value="form.quantidadeTotal"
        type="number"
        :label="$t('SUPRIMENTOS.QUANTIDADE_TOTAL')"
        disabled
      />
    </div>

    <div class="col-6">
      <input-text
        ref="quantidade"
        v-model="form.quantidade"
        :disabled="!form.quantidadeTotal"
        :label="$t('SUPRIMENTOS.QUANTIDADE')"
        :placeholder="$t('GERAL.SOMENTE_NUMEROS')"
        type="number"
        :min="1"
        :max="form.quantidadeTotal"
      />
    </div>
  </div>
</template>
<script>
//utils e aux
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

// Components:
import { InputText, InputSelectSearch } from '@/components/inputs';
// import { SelecionarDeposito } from '@/components/selecionar-entidades/modal/index';
import DepositoService from '@/common/services/depositos/depositos.service';
import EstoqueService from '@/common/services/estoque/estoque.service';

export default {
  props: {
    form: { type: Object, default: Object },
    opcoes: {
      type: Object,
      default: () => ({
        depositos: [],
        produtos: [],
      }),
    },
  },
  components: {
    InputSelectSearch,
    InputText,
  },
  data() {
    return {
      depositos: [],
    };
  },
  mounted() {
    this.$emit('refs', this.$refs);
    this.getDepositos();
  },
  methods: {
    getDepositos() {
      this.$store.dispatch(START_LOADING);
      DepositoService.obterTodos()
        .then(({ data }) => {
          this.depositos = data.itens.map((deposito) => ({
            depositoNovoId: deposito.id,
            text: deposito.descricao,
            value: deposito.id,
          }));
        })
        .catch((error) => {
          mensagem.showErrors(error)
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    async buscaDepositoQuantidadeTotal() {
      this.$store.dispatch(START_LOADING);
      this.form.quantidadeTotal = 0;
      await EstoqueService.buscaSaldoTotalProduto({ produtoId: this.form.produtoId, depositoId: this.form?.depositoAntigoId })
      .then(({ data }) => {
          this.form.quantidadeTotal = data;
        })
        .catch((error) => {
          this.form.quantidadeTotal = null;
          mensagem.showErrors(error);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
};
</script>
